import LoggerService from './logger-service';
import { modalUtils } from '@/app/core/utils';
import { useState, useEffect } from 'react';
import ReactJson from 'react-json-view';
import { Spin } from '@ssar-app/uikit';
import { Button, HStack } from '@chakra-ui/react';

export interface LoggerInfoProps {
  id?: string;
  onOk: () => void;
}
export const LoggerInfo = (props: LoggerInfoProps) => {
  const [loading, setLoading] = useState(true);
  const [logInfo, setLogInfo] = useState({});
  const { id, onOk } = props;

  useEffect(() => {
    LoggerService.getLogInfo(id)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .then((res: any) => {
        setLogInfo(res);
        setLoading(false);
      })
      .catch((err) => {
        onOk();
        console.error(err);
        modalUtils.showError(err, 'Error while fetching the log details');
      });
    // .finally(() => {});
  }, [id, onOk]);

  return (
    <Spin spinning={loading}>
      <ReactJson
        src={logInfo}
        name={null}
        enableClipboard={false}
        displayDataTypes={false}
        displayObjectSize={false}
      />
      <HStack justify='end'>
        <Button onClick={onOk} colorScheme='blue' h={8}>
          OK
        </Button>
      </HStack>
    </Spin>
  );
};
